var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerEdgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 35C42.2 35 43.98 32.75 43.98 30L44 5C44 2.25 42.2 0 40 0H8C5.8 0 4 2.25 4 5V30C4 32.75 5.8 35 8 35H0V40H48V35H40ZM8 5H40V30H8V5Z",
    fill: "#495058"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6101 23.3711C32.315 23.5244 32.0108 23.6593 31.6991 23.775C30.7122 24.1423 29.6671 24.3287 28.614 24.325C24.5491 24.325 21.0085 21.532 21.0085 17.9398C21.0138 17.4588 21.1471 16.9879 21.3949 16.5756C21.6426 16.1632 21.9957 15.8243 22.4179 15.5938C18.7397 15.7484 17.7944 19.5812 17.7944 21.8242C17.7944 28.1836 23.6468 28.8195 24.9101 28.8195C25.589 28.8195 26.6116 28.6219 27.2304 28.4242L27.3421 28.3898C29.71 27.5715 31.7286 25.9712 33.0655 23.8523C33.1044 23.788 33.1211 23.7126 33.113 23.6379C33.1049 23.5631 33.0726 23.493 33.0209 23.4384C32.9692 23.3838 32.901 23.3477 32.8268 23.3355C32.7526 23.3233 32.6765 23.3358 32.6101 23.3711Z",
    fill: "url(#paint0_linear_219_844)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.6101 23.3711C32.315 23.5244 32.0108 23.6593 31.6991 23.775C30.7122 24.1423 29.6671 24.3287 28.614 24.325C24.5491 24.325 21.0085 21.532 21.0085 17.9398C21.0138 17.4588 21.1471 16.9879 21.3949 16.5756C21.6426 16.1632 21.9957 15.8243 22.4179 15.5938C18.7397 15.7484 17.7944 19.5812 17.7944 21.8242C17.7944 28.1836 23.6468 28.8195 24.9101 28.8195C25.589 28.8195 26.6116 28.6219 27.2304 28.4242L27.3421 28.3898C29.71 27.5715 31.7286 25.9712 33.0655 23.8523C33.1044 23.788 33.1211 23.7126 33.113 23.6379C33.1049 23.5631 33.0726 23.493 33.0209 23.4384C32.9692 23.3838 32.901 23.3477 32.8268 23.3355C32.7526 23.3233 32.6765 23.3358 32.6101 23.3711Z",
    fill: "url(#paint1_radial_219_844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8338 27.7367C21.0688 27.2616 20.4057 26.6394 19.883 25.9062C19.286 25.0891 18.8751 24.1513 18.679 23.1585C18.483 22.1657 18.5066 21.1421 18.7482 20.1594C18.9898 19.1767 19.4435 18.2588 20.0774 17.47C20.7114 16.6813 21.5104 16.0409 22.4181 15.5937C22.6931 15.4648 23.1486 15.2414 23.7588 15.25C24.1881 15.2533 24.6109 15.3558 24.994 15.5497C25.3771 15.7435 25.7103 16.0232 25.9674 16.3671C26.3131 16.8321 26.5027 17.3947 26.5088 17.9742C26.5088 17.957 28.6142 11.1335 19.6338 11.1335C15.8611 11.1335 12.7588 14.7085 12.7588 17.8539C12.7438 19.5153 13.099 21.1593 13.7986 22.6664C14.9444 25.1061 16.9461 27.0403 19.4238 28.1017C21.9014 29.1631 24.6826 29.2779 27.2392 28.4242C26.3435 28.7071 25.397 28.7921 24.4653 28.6734C23.5335 28.5547 22.6385 28.2351 21.8424 27.7367H21.8338Z",
    fill: "url(#paint2_linear_219_844)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M21.8338 27.7367C21.0688 27.2616 20.4057 26.6394 19.883 25.9062C19.286 25.0891 18.8751 24.1513 18.679 23.1585C18.483 22.1657 18.5066 21.1421 18.7482 20.1594C18.9898 19.1767 19.4435 18.2588 20.0774 17.47C20.7114 16.6813 21.5104 16.0409 22.4181 15.5937C22.6931 15.4648 23.1486 15.2414 23.7588 15.25C24.1881 15.2533 24.6109 15.3558 24.994 15.5497C25.3771 15.7435 25.7103 16.0232 25.9674 16.3671C26.3131 16.8321 26.5027 17.3947 26.5088 17.9742C26.5088 17.957 28.6142 11.1335 19.6338 11.1335C15.8611 11.1335 12.7588 14.7085 12.7588 17.8539C12.7438 19.5153 13.099 21.1593 13.7986 22.6664C14.9444 25.1061 16.9461 27.0403 19.4238 28.1017C21.9014 29.1631 24.6826 29.2779 27.2392 28.4242C26.3435 28.7071 25.397 28.7921 24.4653 28.6734C23.5335 28.5547 22.6385 28.2351 21.8424 27.7367H21.8338Z",
    fill: "url(#paint3_radial_219_844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8469 19.7875C25.7695 19.8734 25.5547 20.0023 25.5547 20.2687C25.5547 20.4922 25.7008 20.7156 25.9672 20.8961C27.1961 21.7555 29.525 21.6352 29.5336 21.6352C30.4497 21.6346 31.3489 21.3882 32.1375 20.9219C32.9314 20.4575 33.5901 19.7937 34.0484 18.9963C34.5066 18.1989 34.7485 17.2955 34.75 16.3758C34.7758 14.4508 34.0625 13.1703 33.7789 12.6031C31.9484 9.04531 28.0211 7 23.75 7C20.8592 6.99971 18.0845 8.13738 16.026 10.1669C13.9675 12.1965 12.7907 14.9548 12.75 17.8453C12.793 14.7086 15.9125 12.1734 19.625 12.1734C19.9258 12.1734 21.6445 12.1992 23.2344 13.0328C24.3513 13.5878 25.2763 14.4649 25.8898 15.5508C26.4141 16.4617 26.5086 17.6219 26.5086 18.0859C26.5086 18.55 26.2766 19.2289 25.8383 19.7961L25.8469 19.7875Z",
    fill: "url(#paint4_radial_219_844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8469 19.7875C25.7695 19.8734 25.5547 20.0023 25.5547 20.2687C25.5547 20.4922 25.7008 20.7156 25.9672 20.8961C27.1961 21.7555 29.525 21.6352 29.5336 21.6352C30.4497 21.6346 31.3489 21.3882 32.1375 20.9219C32.9314 20.4575 33.5901 19.7937 34.0484 18.9963C34.5066 18.1989 34.7485 17.2955 34.75 16.3758C34.7758 14.4508 34.0625 13.1703 33.7789 12.6031C31.9484 9.04531 28.0211 7 23.75 7C20.8592 6.99971 18.0845 8.13738 16.026 10.1669C13.9675 12.1965 12.7907 14.9548 12.75 17.8453C12.793 14.7086 15.9125 12.1734 19.625 12.1734C19.9258 12.1734 21.6445 12.1992 23.2344 13.0328C24.3513 13.5878 25.2763 14.4649 25.8898 15.5508C26.4141 16.4617 26.5086 17.6219 26.5086 18.0859C26.5086 18.55 26.2766 19.2289 25.8383 19.7961L25.8469 19.7875Z",
    fill: "url(#paint5_radial_219_844)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_844",
    x1: 17.7944,
    y1: 22.2109,
    x2: 33.1257,
    y2: 22.2109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_219_844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2593 22.3265) scale(8.19844 7.78852)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_219_844",
    x1: 25.8728,
    y1: 15.5593,
    x2: 16.308,
    y2: 25.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_219_844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8135 24.0961) rotate(-81.3844) scale(12.3222 9.95513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_219_844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9749 11.0662) rotate(92.2906) scale(17.4077 37.0747)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_219_844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3802 13.643) rotate(73.7398) scale(8.36172 6.79975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(12.75 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerEdgeIcon);
export default __webpack_public_path__ + "static/media/computer_edge_icon.db4bb01b.svg";
export { ForwardRef as ReactComponent };